import date from './date'

const created =
{
    ...date,
    label : 'Créé : {0}'
};

export default created ;
